import { useTranslation } from 'react-i18next'
import { Input } from 'antd'

import { SearchIcon } from '@/components/Icons'

import styles from './SearchBar.module.scss'

// type WishlistSearchBarProps = {
//   searchTerm: string;
//   onSearchHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
// };

const WishlistSearchBar = ({ searchTerm = '', onSearchHandler, ...props }) => {
  const { t } = useTranslation()

  return (
    <Input
      {...props}
      allowClear
      className={styles['wishlist-search']}
      placeholder={t('buttonTexts.search')}
      prefix={<SearchIcon className={styles['prefix-icon']} />}
      size="large"
      value={searchTerm}
      onChange={onSearchHandler}
    />
  )
}

export default WishlistSearchBar
